<template>
  <div id="app">
    <Header />
    <VideoContainer v-if="mounted" @resetRC="resetRC" @executeRC="executeRC" @getProducts="getProducts" />
    <!-- <SupplierHero v-if="suppliersLoad && mounted && supplierStarted" @resetRC="resetRC" @executeRC="executeRC" /> -->
    <div v-if="debugging" class="debugging" style="padding: 0.5em;">
      <h3>Debugging</h3>
      <button type="button" @click="resetState">Reset State</button>
      <p>"Reset State" removes your quiz answers and lets you start over. You can also open a new private window.</p>
    </div>
    <!-- <QuizStart v-if="pageMode === 'managers' && active.index === 0" /> -->
    <PersonaSummary v-if="pageMode === 'suppliers'" />
    <UnlockContainer
      v-if="showSupportForm"
      @executeRC="executeRC"
      @resetRC="resetRC"
    />
    <!-- <SupportDescription v-if="pageMode === 'suppliers' && supplierStarted" /> -->
    <RecommendedBanner v-if="pageMode === 'managers' && !resultsComplete" recommended="Office Coffee Support" />
    <RecommendedBanner v-if="pageMode === 'suppliers'" recommended="Your Coffee Sales Arsenal" />
    <!-- <NoTime @getProducts="getProducts" v-if="pageMode === 'managers' && !resultsComplete" /> -->
    <!-- <RecommendedBanner v-if="supplierStarted" recommended="The Busy Bee Recommended Offers" /> -->
    <OfferContainer v-if="!resultsComplete" />
    <RecommendedBanner v-if="pageMode === 'managers' && resultsComplete" recommended="Recommended Brands" />
    <BrandContainer v-if="pageMode === 'managers'" />
    <RecommendedBanner v-if="pageMode === 'managers' && resultsComplete" recommended="Recommended Formats" />
    <FormatContainer 
    v-if="pageMode === 'managers' && resultsComplete"
    />
    <!-- <RecommendedBanner v-if="supplierStarted" recommended="Resources" /> -->
    <!-- <SupportUnlock v-if="pageMode === 'suppliers' && supplierStarted" /> -->
    <!-- <OfferContainer
      v-if="supplierStarted"
      forced="support"
      @executeRC="executeRC"
      @resetRC="resetRC"
    /> -->
    <!-- <RecommendedBanner v-if="supplierStarted" recommended="Offers" />
    <OfferContainer
      v-if="supplierStarted"
      forced="offers"
      @executeRC="executeRC"
      @resetRC="resetRC"
    /> -->
    <!-- <OfferFormContainer
      v-if="supplierStarted"
      @executeRC="executeRC"
      @resetRC="resetRC"
    /> -->
    <div id="products-wrapper">
      <Products 
      v-if="pageMode === 'managers' && resultsComplete && formatOrBrandSet"
      />
    </div>
    <MainFormContainer @executeRC="executeRC" @resetRC="resetRC" />
    <RecommendedBanner v-if="pageMode === 'managers' && resultsComplete" recommended="Office Coffee Support" />
    <OfferContainer v-if="resultsComplete" />
    <Redo v-if="resultsComplete" @getProducts="getProducts" />
    <vue-recaptcha
      size="invisible"
      :sitekey="reCaptchaKey"
      ref="recaptcha"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      @error="onCaptchaError"
    ></vue-recaptcha>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import { reCaptchaKey } from './mixins/reCaptchaKey.js'
import { pageMode } from './mixins/pageMode.js'
import VueRecaptcha from 'vue-recaptcha';
import zenscroll from 'zenscroll'

import Header from './components/Layout/Header.vue'
import Footer from './components/Layout/Footer.vue'

import VideoContainer from './components/VideoContainer.vue'
// import SupplierHero from './components/Layout/SupplierHero.vue'
import BrandContainer from './components/Brands/BrandContainer.vue'
import MainFormContainer from './components/Form/MainFormContainer.vue'
import RecommendedBanner from './components/Layout/RecommendedBanner.vue'
import FormatContainer from './components/Formats/FormatContainer.vue'
import OfferContainer from './components/Formats/OfferContainer.vue'
// import SupportUnlock from './components/SupportUnlock.vue'
import Products from './components/Products.vue'
// import QuizStart from './components/QuizStart.vue'
// import NoTime from './components/NoTime.vue'
import UnlockContainer from './components/UnlockContainer.vue'
// import OfferFormContainer from './components/OfferFormContainer.vue'
import PersonaSummary from './components/PersonaSummary.vue'
// import SupportDescription from './components/Layout/SupportDescription'
import Redo from './components/Redo.vue'

// import QuizProtoType from './components/QuizProtoType.vue'

zenscroll.setup()

export default {
  name: 'App',
  components: {
    Header,
    VideoContainer,
    // SupplierHero,
    BrandContainer,
    Footer,
    // QuizStart,
    MainFormContainer,
    RecommendedBanner,
    FormatContainer,
    OfferContainer,
    VueRecaptcha,
    Products,
    // SupportUnlock,
    // ETailers,
    // NoTime,
    UnlockContainer,
    PersonaSummary,
    // OfferFormContainer,
    // SupportDescription,
    Redo,
    // QuizProtoType
  },
  data() {
    return {
      mounted: false,
      apiUrl: '/api/product/list/',
      pimcoreTagIDs: 
        {
          "busy-bee_100-200": 596,
          "busy-bee_>200": 597,
          "busy-bee_50-100": 595,
          "busy-bee_<50": 593,
          "economist_100-200": 592,
          "economist_>200": 594,
          "economist_50-100": 599,
          "economist_<50": 598,
          "never-settler_100-200": 602,
          "never-settler_>200": 603,
          "never-settler_50-100": 601,
          "never-settler_<50": 600
        },
      debugging: false
    }
  },
  computed: {
    offersUnlocked() {
      return this.$store.state.offersUnlocked
    },
    resultsComplete() {
      return this.$store.state.results.complete
    },
    managersLoad() {
      if (typeof this.pageMode !== 'undefined') {
        return this.pageMode === 'managers' ? true : false
      } else {
        return true
      }
    },
    suppliersLoad() {
      if (typeof this.pageMode !== 'undefined') {
        return this.pageMode === 'suppliers' ? true : false
      } else {
        return false
      }
    },
    formatOrBrandSet() {
      return this.$store.state.format !== '' || this.$store.state.brand !== ''
    },
    active() {
      return this.$store.state.active
    },
    supplierStarted() {
      return this.$store.state.supplierStarted
    },
    showOfferForm() {
      return this.$store.state.supplierVisibleForm == 'offers'
    },
    showSupportForm() {
      return this.$store.state.supplierVisibleForm == 'support'
    }
  },
  mounted () {
    this.mounted = true
  },
  methods: {
    resetState() {
      this.$store.dispatch('resetState')
      if (localStorage) {
        localStorage.removeItem('ocsV3')
      }
    },
    onSubmit() {
      document.getElementById("demo-form").submit();
    },
    executeRC() {
      // console.log('App.vue Execute RC run')
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified(recaptchaToken) {
      // console.log('recaptchaToken', recaptchaToken)
      this.$store.dispatch('verifyReCaptcha', recaptchaToken)
    },
    onCaptchaExpired() {
      // console.log('onCaptchaExpired App.vue:177 - verifyRecaptcha = false')
      this.$store.dispatch('verifyReCaptcha', false)
      this.$refs.recaptcha.reset();
    },
    onCaptchaError() {
      // console.log('onCaptchaError App.vue:182 - verifyRecaptcha = false')
      this.$store.dispatch('verifyReCaptcha', false)
    },
    resetRC() {
      this.$refs.recaptcha.reset();
      this.$refs.recaptcha.execute();
    },
    // formatSelected(format) {
    //   console.log('format Selected: ', format)
    //   this.format = format
    // },
    // brandSelected(brand) {
    //   console.log('brand Selected: ', brand)
    //   this.brand = brand
    // },
    getPersonaTag() {
      let tag = ''
      const number = this.$store.state.quiz.number
      const persona = this.$store.state.results.personaCalculated

      if (number && persona) {
        tag = persona + '_' + number
        return tag
      }
    },
    getProducts() {
      const personaTag = this.getPersonaTag()

      // console.log('getting products for ', personaTag)

      const productApiUrl = this.apiUrl + this.pimcoreTagIDs[personaTag]

      console.log('productApiUrl: ', productApiUrl)

      axios({
        method: 'get',
        url: productApiUrl,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache',
          },
        },
      })
        .then(response => {
          // console.log(response)
          if (response.status != 200) {
            console.error('error response data: ', response.data)
          }
          if (response.status == 200) {
            // console.log('success response data: ', response.data)
            // this.modalActive = true
            this.$store.dispatch('products', response.data.items)
          }
        })
        .catch(error => {
          console.error('error: ', error)
          console.error('apiUrl', productApiUrl)
        })
      },

  },
  mixins: [pageMode, reCaptchaKey]
}
</script>

<style lang="scss">

body {
  scroll-behavior: smooth;
}

</style>
